import { Injectable } from '@angular/core';
import { AppInitService } from './init.service';
import { ReplaySubject } from 'rxjs';

export interface ShopifyVariant {
  variantId: string;
  product_ID: number;
  product: string;
  variantLabel: string;
}
export type ShopifyMap = Record<string, ShopifyVariant>;

@Injectable({
  providedIn: 'root'
})
export class ConfigService {

  private stockProductsFromShopify;

  private domainWebapp;
  private domainDashboard;
  private apiBaseUrlWebapp;
  private apiWebappGet;
  
  private cfg$ = new ReplaySubject<any>(1);
  get config$() { return this.cfg$.asObservable(); }
  get snapshot() { let s; this.cfg$.subscribe(v => s = v).unsubscribe(); return s; };

  constructor(private appInit: AppInitService) { }
  
  load(){
    this.stockProductsFromShopify = this.appInit.snapshot.shopifyProducts;
    this.domainWebapp = this.appInit.snapshot.domainWebapp;
    this.domainDashboard = this.appInit.snapshot.domainDashboard;
    this.apiBaseUrlWebapp = this.appInit.snapshot.apiBaseUrlWebapp;
    this.apiWebappGet = this.appInit.snapshot.apiWebappGet;
  }

  getApiUrlRefactor(label){
    switch(label){
      case 'emailApp':
        return this.apiBaseUrlWebapp+'email/';
      case 'emailDash':
        return this.domainDashboard+'/api-dashboard/email/';
      case 'appBase':
        return this.apiBaseUrlWebapp;
      case 'appGet':
        return this.apiWebappGet;
      default:
        debugger
        return 'ERROR';
    }
  }

  getStockProductsFromShopify(){
    return this.stockProductsFromShopify;
  }

  findVariantBy(
    map: ShopifyMap = this.getStockProductsFromShopify(),
    searchBy: keyof ShopifyVariant,
    value: string | number
  ): ShopifyVariant | undefined {
    const target = String(value);
    return Object.values(map).find(v => String(v[searchBy]) === target);
}
}
